import { INDEX_WORK_YIELD_EVERY } from '../../files/index/constants.js';
import { yieldToEventLoop } from '../../runtime/yield-to-event-loop.js';

/** Standard roots relative to cwd (agent-neutral first, then tool-specific). */
export const SKILL_DISCOVERY_ROOTS = ['.agents/skills', '.claude/skills', '.cursor/skills', 'skills'] as const;

export async function yieldSkillDiscoveryWork(entryCount: number): Promise<void> {
  if (entryCount > 0 && entryCount % INDEX_WORK_YIELD_EVERY === 0) {
    await yieldToEventLoop();
  }
}
